document.addEventListener("DOMContentLoaded", function() {
  requestAnimationFrame(() => {
    var link = document.querySelector(".ht-google-map-button-area a");
    if (link) {
        link.classList.add("button");
    }


    const parentDiv = document.querySelector('.product-info__block-list');
    if (!parentDiv) return;

    const secondChild = parentDiv.querySelector('[data-block-type="price"]');
    const thirdChild = parentDiv.querySelector('[data-block-type="@app"]');

    if (secondChild && thirdChild) {
      // Create wrapper div
      const wrapper = document.createElement('div');
      wrapper.classList.add('new-parent-div');

      // Insert wrapper before the first element to wrap
      parentDiv.insertBefore(wrapper, secondChild);

      // Move both children into wrapper
      wrapper.appendChild(secondChild);
      wrapper.appendChild(thirdChild);
    }
  });
});